import styled, { css } from 'styled-components';

export const Wrapper = styled.div(
  ({ theme }) => css`
    margin-bottom: ${theme.sz.s12};

    @media (min-width: ${theme.sz.md}) {
      margin-bottom: ${theme.sz.s32};
    }
  `,
);

export const CardsWrapper = styled.div(
  () => css`
    width: 100%;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  `,
);

export const Label = styled.div(
  ({ theme }) => css`
    margin-bottom: ${theme.sz.s5};
    text-align: center;
    ${theme.typography.heading.mobile.m}

    @media (min-width: ${theme.sz.md}) {
      margin-bottom: ${theme.sz.s8};
      ${theme.typography.heading.desktop.s}
    }
  `,
);
